import { toQueryParams } from "../utils/url";
import appAxios from "./axios";

export const tourPackagesService = {
    getById: async (id) => {
        const { data } = await appAxios.get(`/app/tour-packages/${id}`);
        return data
    },
    getAll: async (queryParams = {}) => {
        const { data } = await appAxios.get(`/app/tour-packages?` + toQueryParams(queryParams));
        return data
    }
}
